import { render, staticRenderFns } from "./motorxy.vue?vue&type=template&id=333ea3ca&"
import script from "./motorxy.vue?vue&type=script&lang=js&"
export * from "./motorxy.vue?vue&type=script&lang=js&"
import style0 from "./motorxy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports